module.exports = __webpack_public_path__ + "static/media/vector.8e7e64e7.svg";